var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"snip1533"},[_c('figcaption',[_c('blockquote',[_c('p',[_vm._v(_vm._s(_vm.$t(_vm.testimContent.quote)))])]),_c('h3',[_vm._v(_vm._s(_vm.$t(_vm.testimContent.author.name)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }